<template>

  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       style="z-index: 999;width: 373px;background-color: #0000">
    <ratio-div :radio-value="17" v-if="iteminfo.config.isFloat===1">
      <div
        style="position:absolute;display: flex;justify-content: right;align-items: center;background-size:100% 100%; background-color: #CCC"
        class="w-full h-full p-r-20"
        :style="{ backgroundImage: 'url(' + iteminfo.config.btBgImg + ')' }">
        <img class="m-auto" src="../../../assets/common/ic_upload_picture.png" v-if="!iteminfo.config.btBgImg">
        <div :style="{backgroundColor:iteminfo.config.btBgColor,color:iteminfo.config.btTextColor}"
             class="p-h-15  flex-column b-radius-3 p-v-5" style="font-size: 10px">
          {{ iteminfo.config.btText }}
        </div>
      </div>
    </ratio-div>

    <ratio-div :radio-value="17" v-if="iteminfo.config.isFloat===2">
      <div
        style="position:absolute;display: flex;justify-content: right;align-items: center;background-size:100% 100%; background-color: #CCC"
        class="w-full h-full p-r-20"
        :style="{ backgroundImage: 'url(' + iteminfo.config.btBgImg + ')' }">
        <img class="m-auto" src="../../../assets/common/ic_upload_picture.png" v-if="!iteminfo.config.btBgImg">
        <div :style="{backgroundColor:iteminfo.config.btBgColor,color:iteminfo.config.btTextColor}"
             class="p-h-15  flex-column b-radius-3 p-v-5" style="font-size: 10px">
          {{ iteminfo.config.btText }}
        </div>
      </div>
    </ratio-div>

    <ratio-div :radio-value="17" v-if="iteminfo.config.isFloat===3">
      <div
        style="position:absolute;display: flex;justify-content: right;align-items: center;background-size:100% 100%; background-color: #0000"
        class="w-full h-full"
        >
        <div
          style="border-bottom-left-radius: 5px;border-top-left-radius: 5px;font-size: 10px"
          :style="{backgroundColor:iteminfo.config.btBgColor,color:iteminfo.config.btTextColor}"
             class="p-h-10  flex a-center p-v-5">
          <img class=" m-r-5 w-26 h-26"
               src="../../../assets/common/ic_phone@2x.png"
               v-if="!iteminfo.config.btBgImg">
          <img class=" m-r-5 w-26 h-26"
               v-if="iteminfo.config.btBgImg"
               :src="iteminfo.config.btBgImg">
          {{ iteminfo.config.btText }}
        </div>
      </div>
    </ratio-div>

  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'PhoneDisplayWidget',
  components: {
    BaseDisplayWidget,
    RatioDiv,
  },
  props: {
    iteminfo: Object
  },

  data () {
    return {}
  },
  computed: {
    getshowDataList () {
      return this.iteminfo.config.datalist
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
